import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subject } from 'rxjs/Subject';
import { logger } from '../logger';
import { Dictionary } from '../utils';
import { EventBus } from './bus.interfaces';

const observables: Dictionary<Subject<any>> = {};
const busLogger = logger.child('[BUS]');

export const BUS: EventBus = {
  emit(event: string, data: any): void {
    busLogger.debug('Emited', event, ', with data: ', data);
    createObservableIfNeeded(event);
    observables[event].next(data);
  },
  on(event: string): Observable<any> {
    createObservableIfNeeded(event);
    return observables[event];
  }
};

function createObservableIfNeeded(event: string) {
  if (!observables[event]) {
    // TODO Replace ReplaySubject with a Subject
    observables[event] = new ReplaySubject();
  }
}
